import { service } from '../axios';
export function getFlowOperations(params) {
    return service({ url: '/flowUserProcess/getOperations', method: 'get', params });
}
export function getFlowStatus(params) {
    return service({ url: '/flowUserProcess/getFlowStatus', method: 'get', params });
}
export function getFlowHistory(params) {
    return service({ url: '/flowUserProcess/getFlowHistory', method: 'get', params });
}
export function execFlowOperation(data) {
    return service({ url: '/flowUserProcess/execOperation', method: 'post', data });
}
export function getFlowPage(params) {
    return service({ url: '/flowUserProcess/query', method: 'get', params });
}
export function getFlowTabs(params) {
    return service({ url: '/flowUserProcess/getTabs', method: 'get', params });
}
export function getFlowRecord(params) {
    return service({ url: '/flowUserProcess/getFlowRecord', method: 'get', params });
}
export function getFlowApprovalReport(params) {
    return service({ url: '/flowUserProcess/getApprovalReport', method: 'get', params });
}
